import { INameModel } from '@shared/models';

export const generateUserFullName = (name: INameModel) => (name ? `${name.first || ''} ${name.last || ''}` : '');
